import type { Flow, FlowTemplate } from '../types';
import { nodeColors } from '../theme/colors';

export function FlowThumbnail({ flow, className }: { flow: Pick<Flow | FlowTemplate, 'nodes' | 'edges'>; className?: string }) {
  const W = 280;
  const H = 120;
  const pad = 16;
  const nodes = Array.isArray(flow.nodes) ? flow.nodes : [];
  const edges = Array.isArray(flow.edges) ? flow.edges : [];

  const xs = nodes.map((n) => n.position.x);
  const ys = nodes.map((n) => n.position.y);
  const minX = Math.min(...xs, 0);
  const maxX = Math.max(...xs, 1);
  const minY = Math.min(...ys, 0);
  const maxY = Math.max(...ys, 1);
  const sx = (W - pad * 2) / Math.max(1, maxX - minX);
  const sy = (H - pad * 2) / Math.max(1, maxY - minY);

  const pos = (n: { position: { x: number; y: number } }) => ({
    x: pad + (n.position.x - minX) * sx,
    y: pad + (n.position.y - minY) * sy,
  });
  const byId = new Map(nodes.map((n) => [n.id, n]));

  return (
    <svg viewBox={`0 0 ${W} ${H}`} className={className} preserveAspectRatio="xMidYMid meet">
      <rect width={W} height={H} rx={10} className="fill-cloud" />
      {edges.map((e, index) => {
        const s = byId.get(e.source);
        const t = byId.get(e.target);
        if (!s || !t) return null;
        const p1 = pos(s);
        const p2 = pos(t);
        return (
          <line
            key={e.id || `${e.source}-${e.target}-${index}`}
            x1={p1.x}
            y1={p1.y}
            x2={p2.x}
            y2={p2.y}
            stroke={e.isLoopBack ? nodeColors.loop : '#C2CCD8'}
            strokeWidth={1.5}
            strokeDasharray={e.isLoopBack ? '3 3' : undefined}
          />
        );
      })}
      {nodes.map((n, index) => {
        const p = pos(n);
        return <circle key={n.id || `node-${index}`} cx={p.x} cy={p.y} r={6} fill={nodeColors[n.kind] ?? '#64748B'} stroke="#fff" strokeWidth={1.5} />;
      })}
    </svg>
  );
}
